import React from 'react';

import Container from '../common/Container.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function _Statement(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.Statement)) {
        return null;
    }
    let blockProps = {};
    let content = data.Statement;
    let style;
    if (props.config && props.config.config && props.config.config.Block) {
        blockProps = props.config.config.Block;
        content = props.content;
        style = Utilities.Config.getStyle(blockProps, undefined, (propName, propValue, _style) => {
            if (propName.indexOf('Border') < 0) {
                return;
            }
            if (propValue && propValue.value && propValue.unit) {
                _style[propName.replace('Border', '')] = `${propValue.value}${propValue.unit}`;
            }
            return true;
        });
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    <div dangerouslySetInnerHTML={{ __html: content }} style={style} />
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                Utilities.isNullOrWhitespace(data.Statement) &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

const Statement = Token.withContentTokenParsing(
    _Statement,
    {},
    (props, keyword) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.Statement:
                if (!Utilities.isNullOrWhitespace(data.Statement)) {
                    replaceString = Token.cleanTokenValueForReplacement(data.Statement);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString
    }
);
const Tokens = () => [{ display: 'Statement', token: Token.Statement }];
const TypeConfig = {
    panel: {
        block: (firstPageOnly) => {
            const group = 'block';
            let options = [];
            if (firstPageOnly) {
                options = [];
            }
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Only Show On First Page',
                        group,
                        fullWidth: true,
                        name: 'renderOnlyFirst',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Design authenticity statement here',
                        label: 'Statement Design',
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: Utilities.wrapTextForEditor({ text: `{${Token.Statement}}`, token: Token.Statement })
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Border Properties',
                        group,
                        id: 'borderProps',
                        type: 'header'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'border'
                    },
                    {
                        disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                        display: 'Border Spacing',
                        group,
                        name: 'paddingMarginBorder',
                        nameSuffix: 'Border',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'paddingMargin'
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('style', 'Layout', {}, undefined)
    }
};

export {
    Statement as Component,
    Tokens,
    TypeConfig
};